<div class="body-container">
  <div class="pos-abs" id="scroll-down"></div>
  <div class="pos-abs" id="scroll-up"></div>

  <nav class="navbar navbar-expand-lg navbar-darkblue" id="navbar-dark">
    <div class="navbar-inner">
      <div class="container">


        <button type="button" class="navbar-toggler btn btn-burger burger-times static collapsed d-flex d-lg-none ml-2" data-toggle="collapse" data-target="#navbarMenu1-dark" aria-controls="navbarMenu1-dark" aria-expanded="false" aria-label="Toggle navbar menu">
          <span class="bars text-white"></span>
        </button><!-- mobile navbar toggler button -->


        <div class="navbar-intro justify-content-xl-between bgc-transparent">
          <a class="navbar-brand text-white" routerLink="/">
            <img class="pull-left" src="{{rest_server+'img/'+datos_app.logo}}" width="30" height="30" />
            <span> {{datos_app.nombre}}</span>
          </a><!-- /.navbar-brand -->
        </div><!-- /.navbar-intro -->


        <div class="navbar-menu collapse navbar-collapse navbar-backdrop " id="navbarMenu1-dark">

          <div class="navbar-nav">
            <ul class="nav nav-compact-3">

              <li class="nav-item pos-rel dropdown dropdown-mega dropdown-hover">
                <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                  <i class="fa fa-list-alt mr-2 d-lg-none"></i>
                  Paquetes
                  <i class="caret fa fa-angle-down d-none d-lg-block"></i>
                  <i class="caret fa fa-angle-left d-block d-lg-none"></i>
                </a>
                <div class="p-0 dropdown-menu dropdown-center dropdown-lg border-0 shadow radius-2 mt-1 mt-lg-3">
                  <div class="row mx-0">
                    <div class="bgc-white col-lg-6 col-12 p-2 p-lg-3 p-xl-4">
                      <div class="d-flex align-items-center">
                        <div class="pos-rel">
                          <i class="bgc-blue-l3 w-4 h-4 radius-round position-r mr-2 mt-25"></i>
                          <i class="fas fa-user-tie text-160 text-blue mr-2 mb-3 w-6 h-6 radius-round text-center pt-1 pos-rel"></i>
                        </div>
                        <div>
                          <a href="#comercios" class="d-block py-1px px-1 radius-1 no-underline text-dark-tp3 text-600 bgc-h-primary-l2 text-95">
                            Comercios
                          </a>
                          <p class="text-dark-tp4 pl-1">
                            Para cualquier negocio de compra y venta
                          </p>
                        </div>
                      </div>

                      <div class="d-flex align-items-center">
                        <div class="pos-rel">
                          <i class="bgc-green-l3 w-4 h-4 radius-round position-r mr-2 mt-25"></i>
                          <i class="fas fa-utensils text-160 text-green mr-2 mb-3 w-6 h-6 radius-round text-center pt-1 pos-rel"></i>
                        </div>
                        <div>
                          <a href="#restaurantes" class="d-block py-1px px-1 radius-1 no-underline text-dark-tp3 text-600 bgc-h-primary-l2 text-95">
                            Restaurantes
                          </a>
                          <p class="text-dark-tp4 pl-1">
                            Para restaurantes, bares, cafeterias, foodtrucks y otros negocios de comida
                          </p>
                        </div>
                      </div>

                      <div class="d-flex align-items-center">
                        <div class="pos-rel">
                          <i class="bgc-orange-l3 w-4 h-4 radius-round position-r mr-2 mt-25"></i>
                          <i class="fas fa-notes-medical text-160 text-orange-d2 mr-2 mb-3 w-6 h-6 radius-round text-center pt-1 pos-rel"></i>
                        </div>

                        <div>
                          <a href="#" class="d-block py-1px px-1 radius-1 no-underline text-dark-tp3 text-600 bgc-h-primary-l2 text-95">
                            Farmacias
                          </a>
                          <p class="text-dark-tp4 pl-1">
                            Para farmacias y servicios de salud
                          </p>
                        </div>
                      </div>
                    </div><!-- .col:mega links -->

                    <div class="bgc-white col-lg-6 col-12 p-2 p-lg-3 p-xl-4">
                      <div class="d-flex align-items-center">
                        <div class="pos-rel">
                          <i class="bgc-blue-l3 w-4 h-4 radius-round position-r mr-2 mt-25"></i>
                          <i class="fas fa-store text-160 text-blue mr-2 mb-3 w-6 h-6 radius-round text-center pt-1 pos-rel"></i>
                        </div>
                        <div>
                          <a href="#" class="d-block py-1px px-1 radius-1 no-underline text-dark-tp3 text-600 bgc-h-primary-l2 text-95">
                            Micromercados
                          </a>
                          <p class="text-dark-tp4 pl-1">
                            Para micromercados, tiendas de barrio y otros negocios de proximidad
                          </p>
                        </div>
                      </div>

                      <div class="d-flex align-items-center">
                        <div class="pos-rel">
                          <i class="bgc-purple-l3 w-4 h-4 radius-round position-r mr-2 mt-25"></i>
                          <i class="fas fa-hospital text-160 text-purple mr-2 mb-3 w-6 h-6 radius-round text-center pt-1 pos-rel"></i>
                        </div>
                        <div>
                          <a href="#" class="d-block py-1px px-1 radius-1 no-underline text-dark-tp3 text-600 bgc-h-primary-l2 text-95">
                            Consultorios Medicos
                          </a>
                          <p class="text-dark-tp4 pl-1">
                            Para consultorios médicos, laboratorios y servicios de salud
                          </p>
                        </div>
                      </div>

                      <div class="d-flex align-items-center">
                        <div class="pos-rel">
                          <i class="bgc-red-l3 w-4 h-4 radius-round position-r mr-2 mt-25"></i>
                          <i class="fas fa-truck text-160 text-danger mr-2 mb-3 w-6 h-6 radius-round text-center pt-1 pos-rel"></i>
                        </div>
                        <div>
                          <a href="#" class="d-block py-1px px-1 radius-1 no-underline text-dark-tp3 text-600 bgc-h-primary-l2 text-95">
                            Distribuidores
                          </a>
                          <p class="text-dark-tp4 pl-1">
                            Para empresas distribuidoras y proveedores
                          </p>
                        </div>
                      </div>
                    </div><!-- .col:mega links -->
                  </div><!-- .row: mega -->


                  <div class="px-4 mx-0 order-first order-lg-last bgc-primary-l4 border-t-1 brc-secondary-l2">
                    <div class="py-3">
                      <button class="mx-2px btn px-25 py-2 text-100 btn-blue radius-round px-4 border-2">
                        Inicia hoy
                      </button>

                      <div class="d-block d-md-inline-block mt-3 mt-md-0">
                        <span class="text-dark-tp3 ml-3">
                                o llamanos para tener informacion
                              </span>

                        <b class="text-600">
                          +(591)70723756
                        </b>
                      </div>
                    </div>
                  </div><!-- .row:megamenu big buttons -->
                </div>
              </li>

              <li class="nav-item dropdown mx-1px">
                <a class="nav-link" href="#otras_caracteristicas">
                  <i class="fa fa-magic mr-15"></i>
                  Caracteristicas
                </a>
              </li>

              <li class="nav-item dropdown mx-1px">
                <a class="nav-link" href="#">
                  Contacto
                </a>
              </li>

              <li class="nav-item ml-xl-2">
                <a class="d-none d-lg-block nav-link h-auto py-15 mt-1 bgc-black-tp8 bgc-h-black-tp7 text-white radius-1" href="#clientes">
                  Clientes
                </a>

                <a class="d-lg-none nav-link" href="#clientes">
                  ** Clientes **
                </a>
              </li>
            </ul><!-- /.navbar-nav menu -->
          </div><!-- /.navbar-nav -->

        </div><!-- /.navbar-menu.navbar-collapse -->


        <button type="button" class="d-style btn btn-burger static collapsed mr-2 px-4 navbar-toggler d-flex d-lg-none" data-toggle="collapse" data-target="#navbarMenu2-dark" aria-controls="navbarMenu2-dark" aria-expanded="false" aria-label="Toggle navbar menu">
          <i class="fa fa-caret-down d-collapsed text-80"></i>
          <i class="fa fa-caret-up d-n-collapsed text-80"></i>

          <i class="fa fa-user ml-2"></i>
        </button><!-- mobile navbar toggler button -->


        <div class="navbar-menu collapse navbar-collapse navbar-backdrop" id="navbarMenu2-dark">
          <div class="navbar-nav">
            <ul class="nav nav-compact">

              <li class="nav-item dropdown px-lg-2 d-lg-flex flex-column justify-content-center">
                <a class="d-none d-lg-block h-auto btn btn-outline-white btn-bold radius-round border-2 dropdown-toggle px-2 px-xl-3" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                  Ingresar
                </a>

                <a class="d-lg-none nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                  <i class="fa fa-caret-right bgc-white text-blue radius-round py-2 px-3 mr-2"></i>
                  Ingresar
                </a>

                <div style="width: 20rem;" data-display="static" class="dropdown-menu dropdown-menu-right overflow-hidden dropdown-animated animated-2 shadow radius-1 p-2 p-lg-0 border-0 mt-lg-n1 mr-lg-n2">
                  <!-- login dialog -->
                  <h4 class="text-120 mb-3 text-secondary-d3 px-3 mt-3 mb-2">Ingrese sus credenciales</h4>
                  <hr class="border-dotted brc-default-l2" />
                  <form class="dropdown-clickable text-grey-d2" name="loginform" #myForm="ngForm" novalidate>
                    <div class="dropdown-body my-25">
                      <div class="form-group mx-3">
                        <div class="d-flex align-items-center input-floating-label text-blue-m1 brc-blue-m2">
                          <input name="nombre_usuario" type="text" class="form-control pr-4 shadow-none" autocomplete="off" [(ngModel)]="usuario.nombre_usuario" (keypress)="enfocarElemento($event,'clave')"/>
                          <i class="fa fa-user text-grey-m2 ml-n4"></i>
                          <label class="floating-label text-grey-l1 ml-n3">Usuario</label>
                        </div>
                      </div>

                      <div class="form-group mx-3">
                        <div class="d-flex align-items-center input-floating-label text-blue-m1 brc-blue-m2">
                          <input name="clave" type="password" class="form-control pr-4 shadow-none" autocomplete="off" (keypress)="enfocarElemento($event,null)" [(ngModel)]="usuario.clave"/>
                          <i class="fa fa-key text-grey-m2 ml-n4"></i>
                          <label class="floating-label text-grey-l1 ml-n3">Clave</label>
                        </div>
                      </div>

                      <!--<div class="mx-3">
                        <label class="d-inline-block mt-2 text-secondary-d2">
                          <input type="checkbox" class="mr-1" />
                          Remember me
                        </label>
                      </div>-->
                    </div>

                    <div class="dropdown-footer text-center py-25 bgc-default-l4 border-t-1 brc-default-l2">
                      
                      <button (click)="iniciarSesion()" type="button" class="btn btn-info btn-block btn-md btn-bold mt-2 mb-4">
                          Ingresar
                      </button>

                      <!--<button type="button" class="btn px-25 py-15 text-95 btn-outline-green btn-bgc-white">
                        Register
                      </button>-->
                    </div>
                  </form>
                </div>
              </li>


              <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle px-lg-3" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                  <i class="text-140 fa fa-search"></i>
                  <span class="d-lg-none ml-2">
                          Open Search
                      </span>
                </a>
                <div style="width: 20rem;" data-display="static" class="dropdown-menu dropdown-menu-right dropdown-animated animated-2 dropdown-caret radius-1 p-2 p-lg-0 border-0 mt-lg-n1 mr-lg-n2 shadow">
                  <form class="dropdown-clickable text-grey-d2">
                    <div class="dropdown-body my-25">
                      <div class="px-2 px-md-3">
                        <input type="text" class="form-control shadow-none m-0" placeholder="Enter Keywords to Search ..." />
                      </div>
                    </div>

                    <div class="dropdown-footer py-2 text-center pos-rel border-t-1 brc-secondary-l2">
                      <button type="button" class="btn px-4 btn-sm btn-primary" data-dismiss="dropdown">Find</button>
                      <button type="reset" class="btn btn-sm btn-outline-secondary">Clear</button>
                    </div>
                  </form>
                </div>
              </li>


              <li class="nav-item">
                <a href="#" class="nav-link">
                  <i class="text-140 far fa-heart text-yellow-l3"></i>
                  <span class="d-lg-none ml-2 text-yellow-l3">
                          Bookmark
                      </span>
                </a>
              </li>


              <li class="nav-item px-3 py-3">
                <span class="text-white p-2 border-b-3 brc-white-tp5 bgc-h-white-tp9 radius-t-1">
                      <i class="fa fa-phone fa-flip-horizontal text-125 text-green-l4 mr-1"></i>
  
                      <span class="text-90 ml-1 ml-lg-0 d-lg-none d-xl-inline-block">
                          LLAMA AHORA
                      </span>

                <span class="ml-1 text-600 letter-spacing-1 d-lg-none d-xl-inline-block">
                          +(591)70723756
                      </span>
                </span>
              </li>

            </ul>
          </div>
        </div><!-- .navbar-menu -->



      </div><!-- /.container -->
    </div><!-- /.navbar-inner -->
  </nav>
  <nav class="navbar navbar-expand-lg navbar-white d-none" id="navbar-light">
    <div class="navbar-inner">
      <div class="container">


        <button type="button" class="btn btn-burger burger-times static navbar-toggler collapsed d-flex d-lg-none ml-2" data-toggle="collapse" data-target="#navbarMenu1-light" aria-controls="navbarMenu1-light" aria-expanded="false" aria-label="Toggle navbar menu">
          <span class="bars text-dark-tp3"></span>
        </button><!-- mobile navbar toggler button -->


        <div class="navbar-intro justify-content-xl-between border-0 w-auto">
          <a class="navbar-brand text-dark-tp3 text-180" href="#">
            <i class="fa fa-leaf text-105 text-success-m2 mr-1"></i>
            <img class="pull-left" src="{{rest_server+'img/'+datos_app.logo}}" width="30" height="30" />
            <span> {{datos_app.nombre}}</span>
          </a><!-- /.navbar-brand -->
        </div><!-- /.navbar-intro -->



        <div class="navbar-menu collapse navbar-collapse navbar-backdrop " id="navbarMenu1-light">

          <div class="navbar-nav">
            <ul class="nav nav-compact-3">

              <li class="nav-item dropdown dropdown-mega pos-rel dropdown-hover">
                <a class="btn btn-white btn-text-dark btn-h-default btn-a-default border-0 dropdown-toggle" href="#" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                  <i class="fa fa-list-alt mr-2 d-lg-none"></i>
                  Mega
                  <i class="caret fa fa-angle-down d-none d-lg-block"></i>
                  <i class="caret fa fa-angle-left d-block d-lg-none"></i>
                </a>
                <div class="p-0 dropdown-menu dropdown-center dropdown-lg border-0 shadow border-t-2 brc-primary-m2 radius-b-2 mt-1 mt-lg-3">
                  <div class="row mx-0">
                    <div class="bgc-white col-lg-6 col-12 p-2 p-lg-3 p-xl-4">
                      <div class="d-flex align-items-center">
                        <div class="pos-rel">
                          <i class="bgc-blue-l3 w-4 h-4 radius-round position-r mr-2 mt-25"></i>
                          <i class="fa fa-edit text-160 text-blue mr-2 mb-3 w-6 h-6 radius-round text-center pt-1 pos-rel"></i>
                        </div>
                        <div>
                          <a href="#" class="d-block py-1px px-1 radius-1 no-underline text-dark-tp3 text-600 bgc-h-primary-l2 text-95">
                            New Post
                          </a>
                          <p class="text-dark-tp4 pl-1">
                            Praesent commodo cursus...
                          </p>
                        </div>
                      </div>

                      <div class="d-flex align-items-center">
                        <div class="pos-rel">
                          <i class="bgc-green-l3 w-4 h-4 radius-round position-r mr-2 mt-25"></i>
                          <i class="far fa-comments text-160 text-green mr-2 mb-3 w-6 h-6 radius-round text-center pt-1 pos-rel"></i>
                        </div>
                        <div>
                          <a href="#" class="d-block py-1px px-1 radius-1 no-underline text-dark-tp3 text-600 bgc-h-primary-l2 text-95">
                            Comments
                          </a>
                          <p class="text-dark-tp4 pl-1">
                            Donec id elit non mi...
                          </p>
                        </div>
                      </div>

                      <div class="d-flex align-items-center">
                        <div class="pos-rel">
                          <i class="bgc-orange-l3 w-4 h-4 radius-round position-r mr-2 mt-25"></i>
                          <i class="far fa-star text-160 text-orange-d2 mr-2 mb-3 w-6 h-6 radius-round text-center pt-1 pos-rel"></i>
                        </div>

                        <div>
                          <a href="#" class="d-block py-1px px-1 radius-1 no-underline text-dark-tp3 text-600 bgc-h-primary-l2 text-95">
                            Favorites
                          </a>
                          <p class="text-dark-tp4 pl-1">
                            Commodo tortor mauri...
                          </p>
                        </div>
                      </div>
                    </div><!-- .col:mega links -->

                    <div class="bgc-white col-lg-6 col-12 p-2 p-lg-3 p-xl-4">
                      <div class="d-flex align-items-center">
                        <div class="pos-rel">
                          <i class="bgc-blue-l3 w-4 h-4 radius-round position-r mr-2 mt-25"></i>
                          <i class="fa fa-globe text-160 text-blue mr-2 mb-3 w-6 h-6 radius-round text-center pt-1 pos-rel"></i>
                        </div>
                        <div>
                          <a href="#" class="d-block py-1px px-1 radius-1 no-underline text-dark-tp3 text-600 bgc-h-primary-l2 text-95">
                            Links
                          </a>
                          <p class="text-dark-tp4 pl-1">
                            Praesent commodo cursus...
                          </p>
                        </div>
                      </div>

                      <div class="d-flex align-items-center">
                        <div class="pos-rel">
                          <i class="bgc-purple-l3 w-4 h-4 radius-round position-r mr-2 mt-25"></i>
                          <i class="far fa-copy text-160 text-purple mr-2 mb-3 w-6 h-6 radius-round text-center pt-1 pos-rel"></i>
                        </div>
                        <div>
                          <a href="#" class="d-block py-1px px-1 radius-1 no-underline text-dark-tp3 text-600 bgc-h-primary-l2 text-95">
                            Documents
                          </a>
                          <p class="text-dark-tp4 pl-1">
                            Donec id elit non mi...
                          </p>
                        </div>
                      </div>

                      <div class="d-flex align-items-center">
                        <div class="pos-rel">
                          <i class="bgc-red-l3 w-4 h-4 radius-round position-r mr-2 mt-25"></i>
                          <i class="fa fa-list text-160 text-danger mr-2 mb-3 w-6 h-6 radius-round text-center pt-1 pos-rel"></i>
                        </div>
                        <div>
                          <a href="#" class="d-block py-1px px-1 radius-1 no-underline text-dark-tp3 text-600 bgc-h-primary-l2 text-95">
                            Mega Menu
                          </a>
                          <p class="text-dark-tp4 pl-1">
                            Commodo tortor mauri...
                          </p>
                        </div>
                      </div>
                    </div><!-- .col:mega links -->
                  </div><!-- .row: mega -->


                  <div class="px-4 mx-0 order-first order-lg-last bgc-primary-l4 border-t-1 brc-secondary-l2">
                    <div class="py-3">
                      <button class="mx-2px btn px-25 py-2 text-100 btn-blue radius-round px-4 border-2">
                        Get Started Now
                      </button>

                      <div class="d-block d-md-inline-block mt-3 mt-md-0">
                        <span class="text-dark-tp3 ml-3">
                                or call us now to learn more
                              </span>

                        <b class="text-600">
                          111-222-333
                        </b>
                      </div>
                    </div>
                  </div><!-- .row:megamenu big buttons -->
                </div>
              </li>

              <li class="nav-item dropdown mx-1px">
                <a class="btn btn-white btn-text-dark btn-h-default btn-a-default border-0" href="#">
                  <i class="fa fa-magic mr-15 opacity-1"></i> Features
                </a>
              </li>

              <li class="nav-item dropdown mx-1px">
                <a class="btn btn-white btn-h-default btn-a-default border-0" href="#">
                  Contact
                </a>
              </li>

              <li class="nav-item ml-xl-2">
                <a class="btn btn-lighter-orange text-orange-d3 border-1 d-none d-lg-inline-flex" href="#">
                  *Special Offer*
                </a>
                <a class="btn btn-lighter-orange text-orange-d3 d-lg-none" href="#">
                  *Special Offer*
                </a>
              </li>
            </ul><!-- /.navbar-nav menu -->
          </div><!-- /.navbar-nav -->

        </div><!-- /.navbar-menu.navbar-collapse -->



        <button type="button" class="d-style mr-2 px-4 navbar-toggler btn btn-burger static collapsed d-flex d-lg-none" data-toggle="collapse" data-target="#navbarMenu2-light" aria-controls="navbarMenu2-light" aria-expanded="false" aria-label="Toggle navbar menu">
          <i class="fa fa-caret-down d-collapsed text-grey-m1 text-80"></i>
          <i class="fa fa-caret-up d-n-collapsed text-grey-m1 text-80"></i>

          <i class="fa fa-user text-orange-d1 ml-2"></i>
        </button><!-- mobile navbar toggler button -->


        <div class="navbar-menu collapse navbar-collapse navbar-backdrop " id="navbarMenu2-light">
          <div class="navbar-nav">
            <ul class="nav">

              <li class="nav-item dropdown px-lg-2 d-lg-flex flex-column justify-content-center">
                <a class="d-none d-lg-block h-auto btn btn-outline-blue btn-bold radius-round border-2 dropdown-toggle px-2 px-xl-3" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                  Login
                </a>

                <a class="d-lg-none nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                  <i class="fa fa-caret-right bgc-blue radius-round text-white py-2 px-3 mr-2"></i>
                  Login
                </a>

                <div style="width: 20rem;" data-display="static" class="dropdown-menu dropdown-menu-right overflow-hidden dropdown-animated animated-2 shadow radius-1 p-0 brc-primary-m3 mt-lg-n1 mr-lg-n2">
                  <!-- login dialog -->
                  <h4 class="text-120 mb-3 text-secondary-d3 px-3 mt-3 mb-2">Please enter your details</h4>
                  <hr class="border-dotted brc-default-l2" />
                  <form class="dropdown-clickable text-grey-d2">
                    <div class="dropdown-body my-25">
                      <div class="form-group mx-3">
                        <div class="d-flex align-items-center input-floating-label text-blue-m1 brc-blue-m2">
                          <input type="text" class="form-control pr-4 shadow-none" autocomplete="off" />
                          <i class="fa fa-user text-grey-m2 ml-n4"></i>
                          <label class="floating-label text-grey-l1 ml-n3">Username</label>
                        </div>
                      </div>

                      <div class="form-group mx-3">
                        <div class="d-flex align-items-center input-floating-label text-blue-m1 brc-blue-m2">
                          <input type="password" class="form-control pr-4 shadow-none" autocomplete="off" />
                          <i class="fa fa-key text-grey-m2 ml-n4"></i>
                          <label class="floating-label text-grey-l1 ml-n3">Password</label>
                        </div>
                      </div>

                      <div class="mx-3">
                        <label class="d-inline-block mt-2 text-secondary-d2">
                          <input type="checkbox" class="mr-1" />
                          Remember me
                        </label>
                      </div>
                    </div>

                    <div class="dropdown-footer text-center py-25 bgc-default-l4 border-t-1 brc-default-l2">
                      <button type="button" class="btn px-4 py-15 text-95 btn-blue" data-dismiss="dropdown">
                        Login
                      </button>

                      <button type="button" class="btn px-25 py-15 text-95 btn-outline-green btn-bgc-white">
                        Register
                      </button>
                    </div>
                  </form>
                </div>
              </li>


              <li class="nav-item dropdown border-l-1 brc-secondary-l2">
                <a href="#" class="nav-link dropdown-toggle px-lg-3" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                  <i class="text-140 fa fa-search text-grey-m1"></i>
                  <span class="d-lg-none ml-2 text-blue-d1">Open Search</span>
                </a>
                <div style="width: 20rem;" data-display="static" class="dropdown-menu dropdown-menu-right dropdown-caret dropdown-animated animated-2 shadow radius-1 p-0  border-1 brc-primary-m3 mt-lg-n1 mr-lg-n2">
                  <form class="dropdown-clickable text-grey-d2">
                    <div class="dropdown-body my-25">
                      <div class="px-2 px-md-3">
                        <input type="text" class="form-control shadow-none m-0" placeholder="Enter Keywords to Search ..." />
                      </div>
                    </div>

                    <div class="dropdown-footer py-2 text-center pos-rel border-t-1 brc-secondary-l2">
                      <button type="button" class="btn px-4 btn-sm btn-primary" data-dismiss="dropdown">Find</button>
                      <button type="reset" class="btn btn-sm btn-outline-secondary">Clear</button>
                    </div>
                  </form>
                </div>
              </li>


              <li class="nav-item border-l-1 brc-secondary-l2">
                <a href="#" class="nav-link">
                  <i class="text-140 far fa-heart text-purple-m1"></i>
                  <span class="d-lg-none ml-2 text-purple-d1">
                          Bookmark
                      </span>
                </a>
              </li>

              <li class="nav-item px-3 border-l-1 brc-secondary-l2">
                <span class="d-flex h-100 align-items-center text-grey-d1 py-3">
                      <i class="fa fa-phone fa-flip-horizontal text-125 text-success-m1 mr-1"></i>
                      
                      <span class="text-90 ml-1 ml-lg-0 d-lg-none d-xl-inline-block">
                          LLAMA AHORA
                      </span>

                <span class="ml-1 text-600 text-grey-d3 letter-spacing-1 d-lg-none d-xl-inline-block">
                          (591+)70723756
                      </span>
                </span>
              </li>

            </ul>
          </div>
        </div><!-- .navbar-menu -->


      </div><!-- /.container -->
    </div><!-- /.navbar-inner -->
  </nav>
  <div class="main-container bgc-white">

    <div role="main" class="main-content">
      <div class="page-content p-0">
        <!-- the page intro for dark theme -->
        <div id="page-intro-dark" class="page-intro pos-rel navbar-darkblue py-2 pt-xl-4 py-xl-5 text-white">

          <!-- some random circles -->
          <div class="d-none d-lg-block">
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.16;width:4px; height:4px; top:30%; left:85%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.2;width:6px; height:6px; top:91%; left:15%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.3;width:8px; height:8px; top:1%; left:87%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.24;width:6px; height:6px; top:0%; left:70%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.17;width:16px; height:16px; top:79%; left:20%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.35;width:6px; height:6px; top:10%; left:0%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.17;width:14px; height:14px; top:16%; left:87%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.15;width:17px; height:17px; top:82%; left:71%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.2;width:12px; height:12px; top:17%; left:92%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.19;width:12px; height:12px; top:44%; left:64%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.27;width:11px; height:11px; top:43%; left:89%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.18;width:9px; height:9px; top:55%; left:25%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.38;width:10px; height:10px; top:5%; left:71%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.11;width:9px; height:9px; top:62%; left:22%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.39;width:18px; height:18px; top:47%; left:3%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.18;width:6px; height:6px; top:12%; left:20%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.34;width:10px; height:10px; top:97%; left:95%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.33;width:7px; height:7px; top:74%; left:87%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.17;width:7px; height:7px; top:84%; left:72%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.14;width:9px; height:9px; top:7%; left:23%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.39;width:15px; height:15px; top:94%; left:91%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.28;width:14px; height:14px; top:60%; left:83%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.3;width:15px; height:15px; top:65%; left:66%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.1;width:7px; height:7px; top:3%; left:95%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.39;width:10px; height:10px; top:20%; left:53%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.14;width:13px; height:13px; top:13%; left:77%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.38;width:13px; height:13px; top:76%; left:13%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.19;width:16px; height:16px; top:9%; left:42%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.21;width:16px; height:16px; top:37%; left:69%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.11;width:4px; height:4px; top:21%; left:95%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.16;width:10px; height:10px; top:76%; left:74%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.16;width:17px; height:17px; top:9%; left:88%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.21;width:15px; height:15px; top:79%; left:131%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.37;width:14px; height:14px; top:94%; left:8%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.2;width:9px; height:9px; top:65%; left:87%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.1;width:16px; height:16px; top:4%; left:93%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.32;width:18px; height:18px; top:36%; left:81%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.35;width:7px; height:7px; top:0%; left:21%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.22;width:11px; height:11px; top:69%; left:82%;"></div>
            <div class="pos-abs bgc-white radius-round" style="opacity: 0.32;width:6px; height:6px; top:68%; left:79%;"></div>
          </div>


          <div class="row container container-plus mx-auto mt-3 mb-5">
            <div class="col-12 col-md-7 d-flex flex-column justify-content-center text-center" data-aos="fade-right" data-aos-delay="100">
              <h1 class="align-self-center">
                <span class="text-110 text-yellow-l3">Nuestra tecnología</span><span class="text-90"> te facilita la vida......</span>
              </h1>

              <h4 class="my-3 text-white text-120">
                ¡Empieza a usar esta increíble app y verás resultados al instante!
              </h4>

              <!--<h6 class="my-3 text-105  px-3 radius-3px">
                Or put a slideshow here ...
              </h6>


              <div class="mt-3 row justify-content-center align-items-center">
                <div class="col-12 col-sm-6 col-lg-5 col-xl-4 pos-rel">
                  <i class="fa fa-hand-point-right fa-2x position-l ml-n4 mt-2"></i>
                  <select autocomplete="off" class="no-border theme-select form-control ace-select border-1 brc-white-tp9 shadow-none bgc-white-tp10 bgc-h-black-tp10 text-white text-600 h-auto">
                    <option value="" class="text-600">Change Theme/Color</option>
                    <option value="" class="text-secondary-l3">_______________________</option>
                    <option value="darkblue" class="text-primary-d1 text-600">Blue</option>
                    <option value="teal" class="text-green-d1 text-600">Green</option>
                    <option value="purple" class="text-purple-d1 text-600">Purple</option>
                    <option value="" class="text-secondary-l3">_______________________</option>
                    <option value="light" class="bgc-primary-l3">Light</option>
                    <option value="white">White</option>
                  </select>
                </div>
              </div>


              <div class="text-center mt-3">
                <button type="button" class="btn btn-info brc-white-tp5 py-2 text-110 px-475 mx-15 mb-1 mb-lg-0">
                  <span class="position-tl w-102 h-102 m-n1px bgc-success-tp4 opacity-5"></span>
                  <span class="pos-rel">
                Action 1
            </span>
                </button>

                <button type="button" class="btn btn-outline-white brc-white-tp3 py-2 text-110 px-475 mx-15">
                  Action 2
                </button>
              </div>-->
            </div><!-- /.col -->


            <div class="col-12 col-md-5 order-first order-md-last mb-4 mb-md-0" data-aos="fade-left">
              <img alt="Product Image" src="{{rest_server}}img/preview.png" class="w-90 1mx-auto" />
            </div><!-- /.col -->
          </div><!-- /.row -->

        </div><!-- /#page-intro-dark -->




        <!-- the page intro for light theme -->
        <div id="page-intro-light" class="d-none page-intro pos-rel bgc-primary-l4 py-2 pt-xl-4 py-xl-5 overflow-hidden">

          <!-- some random shapes -->
          <div class="d-none d-lg-block">
            <div class="pos-abs bgc-primary radius-round" style="opacity: 0.25;width:17px; height:17px; top:89%; left:90%;"></div>
            <div class="pos-abs bgc-primary radius-round" style="opacity: 0.36;width:15px; height:15px; top:20%; left:61%;"></div>
            <div class="pos-abs bgc-green radius-round" style="opacity: 0.38;width:10px; height:10px; top:78%; left:93%;"></div>
            <div class="pos-abs bgc-primary radius-round" style="opacity: 0.2;width:12px; height:12px; top:13%; left:64%;"></div>
            <div class="pos-abs bgc-primary radius-round" style="opacity: 0.37;width:18px; height:18px; top:27%; left:88%;"></div>
            <div class="pos-abs bgc-green radius-round" style="opacity: 0.31;width:15px; height:15px; top:32%; left:56%;"></div>
            <div class="pos-abs bgc-primary radius-round" style="opacity: 0.34;width:16px; height:16px; top:35%; left:90%;"></div>
            <div class="pos-abs bgc-green radius-round" style="opacity: 0.36;width:17px; height:17px; top:76%; left:32%;"></div>
            <div class="pos-abs bgc-green radius-round" style="opacity: 0.3;width:14px; height:14px; top:16%; left:91%;"></div>
            <div class="pos-abs bgc-green radius-2px" style="opacity: 0.25;width:17px; height:17px; top:67%; left:96%; transform: rotate(355deg)"></div>
            <div class="pos-abs bgc-primary radius-2px" style="opacity: 0.39;width:19px; height:19px; top:63%; left:58%; transform: rotate(325deg)"></div>
            <div class="pos-abs bgc-orange radius-2px" style="opacity: 0.26;width:23px; height:23px; top:49%; left:58%; transform: rotate(280deg)"></div>
            <div class="pos-abs bgc-primary radius-2px" style="opacity: 0.27;width:12px; height:12px; top:57%; left:92%; transform: rotate(354deg)"></div>
            <div class="pos-abs brc-primary shape-triangle radius-1" style="opacity: 0.39;border-width:0 17px 27px 17px; top:14%; left:63%; transform: rotate(130deg)"></div>
            <div class="pos-abs brc-green shape-triangle radius-1" style="opacity: 0.22;border-width:0 12px 19px 12px; top:15%; left:97%; transform: rotate(346deg)"></div>
            <div class="pos-abs brc-orange shape-triangle radius-1" style="opacity: 0.35;border-width:0 19px 30px 19px; top:69%; left:82%; transform: rotate(319deg)"></div>
            <div class="pos-abs brc-green shape-triangle radius-1" style="opacity: 0.31;border-width:0 19px 30px 19px; top:6%; left:29%; transform: rotate(59deg);"></div>
            <div class="pos-abs brc-orange shape-triangle radius-1" style="opacity: 0.21;border-width:0 14px 22px 14px; top:57%; left:95%; transform: rotate(333deg)"></div>
            <div class="pos-abs brc-primary shape-triangle radius-1" style="opacity: 0.24;border-width:0 16px 25px 16px; top:46%; left:50%; transform: rotate(33deg)"></div>
            <div class="pos-abs bgc-primary radius-round" style="opacity: 0.29;width:18px; height:18px; top:11%; left:78%;"></div>
            <div class="pos-abs bgc-green radius-round" style="opacity: 0.34;width:11px; height:11px; top:10%; left:73%;"></div>
            <div class="pos-abs bgc-orange radius-round" style="opacity: 0.31;width:17px; height:17px; top:39%; left:92%;"></div>
            <div class="pos-abs bgc-orange radius-2px" style="opacity: 0.38;width:19px; height:19px; top:79%; left:14%; transform: rotate(339deg)"></div>
            <div class="pos-abs bgc-primary radius-round" style="opacity: 0.21;width:14px; height:14px; top:85%; left:14%;"></div>
            <div class="pos-abs bgc-green radius-round" style="opacity: 0.27;width:11px; height:11px; top:44%; left:15%;"></div>
            <div class="pos-abs bgc-primary radius-2px" style="opacity: 0.25;width:13px; height:13px; top:32%; left:13%; transform: rotate(331deg)"></div>
          </div>


          <div class="row container container-plus mx-auto mt-4 mb-5">
            <div class="col-12 col-md-7 d-flex flex-column justify-content-center text-center" data-aos="fade-right" data-aos-delay="100">
              <h1 class="text-dark-m2 pb-2 align-self-center">
                <span class="text-blue-d3">
            Our tech
        </span>

                <span class="text-90">
            makes your life easier...
        </span>
              </h1>

              <h4 class="my-3 text-dark-tp2">
                Start using this amazing app and see instant results!
              </h4>

              <h6 class="my-3 bgc-blue-d2 text-120 text-white align-self-center p-2 radius-3px">
                Or put a slideshow here ...
              </h6>

              <div class="mt-1 mb-3">
                <div class="text-uppercase text-600 text-95 text-dark-m3 mb-1">
                  Get it from
                </div>

                <a href="#" class="no-underline">
                  <img alt="Google Play Button" src="{{rest_server}}img/google-play-badge.png" width="180" />
                </a>

                <a href="#" class="no-underline">
                  <img alt="Apple Store Button" src="{{rest_server}}img/app-store-badge.svg" width="145" />
                </a>
              </div>

              <div class="mt-0 form-group">
                <select autocomplete="off" class="theme-select col-12 col-sm-6 col-lg-5 col-xl-4 mx-auto form-control ace-select border-1 bgc-white brc-info-m1 text-dark-m3 h-auto py-1">
                  <option value="" class="text-600">Change Theme/Color</option>
                  <option value="" class="text-secondary-l3">_______________________</option>
                  <option value="darkblue" class="text-primary-d1 text-600">Blue</option>
                  <option value="teal" class="text-green-d1 text-600">Green</option>
                  <option value="purple" class="text-purple-d1 text-600">Purple</option>
                  <option value="" class="text-secondary-l3">_______________________</option>
                  <option value="light" class="bgc-primary-l3">Light</option>
                  <option value="white">White</option>
                </select>
              </div>
            </div><!-- /.col -->

            <div class="col-12 col-md-5 order-first order-md-last mb-4 mb-md-0" data-aos="fade-left">
              <img alt="Product Image" src="{{rest_server}}img/preview.png" class="w-90 1mx-auto" />
            </div><!-- /.col -->
          </div><!-- /.row -->

        </div><!-- /#page-intro-light -->




        <div class="bgc-white">
          <!-- or use a different color -->

          <div class="container container-plus pos-rel mt-n5 text-center py-2">

            <div class="row mt-n4">
              <div class="col-12 col-lg-10 col-xl-8 mx-auto">
                <div class="row my-4">
                  <!-- features -->
                  <div class="col-12 col-md-4 mb-4 mb-md-0" data-aos="fade-up" data-aos-delay="300">
                    <div class="feature-item radius-2 bgc-white shadow-1 p-4 h-100">
                      <div class="d-inline-block pos-rel text-center py-2 px-3 text-150">
                        <!-- the lines beneath icon -->
                        <div class="rotate-n45 brc-purple-m4 border-t-2 w-75 position-tl mt-35 mr-1"></div>
                        <div class="rotate-n45 brc-purple-m4 border-t-3 w-90 position-br mr-1 mb-425"></div>
                        <div class="rotate-n45 brc-purple-m4 border-t-2 w-90 position-bl mb-4 ml-35"></div>

                        <i class="fa fa-rocket fa-2x text-purple-d1 pos-rel"></i>
                      </div>

                      <h3 class="text-secondary-d3 text-160 my-3">
                        Velocidad
                      </h3>

                      <p class="text-dark-m3">
                        En el mundo digital, la velocidad lo es todo. Optimiza tu rendimiento, automatiza tus tareas cotidianas e incrementa tu productividad con una app creada para que alcances tus metas en tiempo récord y sin esfuerzo.
                      </p>
                    </div>
                  </div>


                  <div class="col-12 col-md-4 mb-4  mb-md-0" data-aos="fade-up" data-aos-delay="450">
                    <div class="feature-item radius-2 bgc-white shadow-1 p-4 h-100">
                      <div class="d-inline-block pos-rel text-center p-2 text-150">
                        <!-- the lines beneath icon -->
                        <div class="brc-blue-m4 border-t-2 w-75 position-tl mt-3 ml-n2"></div>
                        <div class="brc-blue-m4 border-t-3 w-90 position-lc ml-n1 mt-n2"></div>
                        <div class="brc-blue-m4 border-t-2 w-90 position-bl mb-4 ml-n3"></div>

                        <i class="fa fa-running fa-2x text-blue-d1 pos-rel"></i>
                      </div>

                      <h3 class="text-secondary-d3 text-160 my-3">
                        Flexibilidad
                      </h3>

                      <p class="text-dark-m3">
                        Trabaja a tu propio ritmo y sin barreras: incrementa tu productividad gracias a la flexibilidad de nuestra app, diseñada para adaptarse perfectamente a tu estilo de vida y darte la velocidad que necesitas para reaccionar ante cualquier desafío en tiempo récord.
                      </p>
                    </div>
                  </div>


                  <div class="col-12 col-md-4 mb-4 mb-md-0" data-aos="fade-up" data-aos-delay="600">
                    <div class="feature-item radius-2 bgc-white shadow-1 p-4 h-100">
                      <div class="d-inline-block text-center p-2 text-150 pos-rel">
                        <!-- the circles beneath icon -->
                        <div class="brc-orange-m4 border-2 w-3 h-3 radius-round position-tl mt-2 ml-n1"></div>
                        <div class="brc-orange-m4 border-2 w-2 h-2 radius-round position-tr mt-n1 ml-n1"></div>
                        <div class="brc-orange-m4 border-2 w-4 h-4 radius-round position-br mb-2"></div>

                        <i class="fa fa-key fa-2x text-orange pos-rel"></i>
                      </div>

                      <h3 class="text-secondary-d3 text-160 my-3">
                        Seguridad
                      </h3>

                      <p class="text-dark-m3">
                        Trabaja con la mente despejada y sin preocupaciones: incrementa tu productividad con nuestra app, un entorno blindado y de máxima seguridad diseñado para proteger tu información confidencial mientras tú te concentras exclusivamente en alcanzar tus metas.
                      </p>
                    </div>
                  </div>

                </div><!-- /.row -->
              </div><!-- /.col -->
            </div><!-- /.row -->

          </div><!-- /.container -->
        </div>




        <div class="bgc-white">
          <!-- or use a different color -->

          <div class="container container-plus py-3 pos-rel">
            <!-- the large circle on right the green square on left -->
            <div data-aos="zoom-in" class="d-none d-lg-block  position-br bgc-purple-l3 mb-5 mr-5 opacity-1 radius-100" style="width: 180px; max-width: 80vw; height: 180px; max-height: 80vw;"></div>
            <div data-aos="zoom-in" class="d-none d-lg-block position-lc bgc-success-l3 opacity-1 ml-5 mt-5 radius-1" style="width: 100px; height: 100px;"></div>


            <div class="row pt-45 mt-1 mt-lg-5">
              <div class="col-12 col-lg-10 col-xl-8 mx-auto">
                <div class="d-flex flex-column align-items-center flex-md-row align-items-md-start">
                  <div class="radius-2 mt-1 mr-md-5 pos-rel" data-aos="fade">
                    <!-- the small squares -->
                    <div class="position-tl bgc-grey-l3 mt-n45 ml-n45 radius-1" style="width: 100px; height: 100px;"></div>
                    <div class="position-br bgc-brown-l3 mb-n45 mr-n45 radius-1" style="width: 110px; height: 110px;"></div>


                    <div class="overflow-hidden radius-1 pos-rel border-1 p-2px brc-secondary-l2 bgc-white">
                      <img alt="Do More" src="{{rest_server}}img/do-more.jpg" width="220" />
                    </div>
                  </div>


                  <div class="flex-grow-1 text-dark-tp3 mt-4 mt-md-0 ml-md-2">
                    <h3 class="text-primary-d2 my-4 text-center text-md-left" data-aos="fade-up">
                      Incrementa tu productividad con nuestra app 
                    </h3>

                    <div data-aos="fade-up">
                      <p>
                        Lleva tu rendimiento al siguiente nivel: optimiza tu tiempo, elimina las distracciones cotidianas e incrementa tu productividad diaria con las herramientas inteligentes de nuestra app, diseñadas exclusivamente para ayudarte a alcanzar tus metas sin estrés
                      </p>
                    </div>
                  </div>
                </div>
              </div><!-- /.col -->
            </div><!-- /.row -->
          </div><!-- /.container -->

        </div>




        <div class="bgc-white mt-4 mt-lg-5">

          <div class="container container-plus py-2 py-lg-4">

            <div class="row">
              <div class="col-12 col-lg-10 col-xl-8 mx-auto">
                <div class="d-flex flex-column align-items-center flex-md-row align-items-md-start">

                  <div class="flex-grow-1 text-dark-tp3 mt-4 mt-md-0">
                    <h3 data-aos="fade-up" class="text-primary-d2 my-4 text-center text-md-left">
                      Diseñado pensando en la flexibilidad.
                    </h3>

                    <div data-aos="fade-up">
                      <p>
                        Diseñado pensando en la flexibilidad, nuestro entorno te permite gestionar tus proyectos desde donde quieras con absoluta tranquilidad. Incrementa tu productividad con nuestra app y descubre el poder de una plataforma moldeable que mantiene tu información siempre blindada y segura.
                      </p>
                    </div>
                  </div>


                  <div class="radius-2 mt-1 ml-md-5 pos-rel order-first order-md-last" data-aos="fade-left">
                    <!-- the small circles -->
                    <div class="position-tr bgc-primary-l3 mt-n45 mr-n45 radius-100" style="width: 80px; max-width: 80vw; height: 80px; max-height: 80vw;"></div>
                    <div class="position-bl bgc-orange-l3 mb-n5 ml-n45 radius-100" style="width: 100px; max-width: 80vw; height: 100px; max-height: 80vw;"></div>

                    <div class="overflow-hidden radius-1 pos-rel border-1 p-2px brc-secondary-l2 bgc-white">
                      <img alt="Be Flexible" src="{{rest_server}}img/be-flexible.jpg" width="220" />
                    </div>
                  </div>
                </div>
              </div><!-- /.col -->
            </div><!-- /.row -->
          </div><!-- /.container -->

        </div>




        <!-- the 3 tabs ... So why is everybody choosing us? -->
        <div class="bgc-white">
          <div class="container container-plus py-35">
            <hr class="brc-secondary-l3 my-4 my-lg-5" />

            <div class="row">
              <div class="col-12 col-lg-8 mx-auto text-center">
                <h3 class="text-dark-l1 mb-4 mt-2 text-180" data-aos="fade-up">
                  Entonces, ¿por qué muchos nos eligen?
                </h3>

                <ul class="d-flex flex-column flex-sm-row d-md-inline-flex nav nav-fill nav-tabs nav-tabs-static mx-n3 mx-md-0 py-1 px-1 px-md-0" role="tablist">
                  <li data-aos="fade-up" data-aos-delay="200" class="nav-item mr-2px mb-1">
                    <a data-toggle="tab" href="#reason1" class="active btn border-1 radius-round py-2 px-35 btn-outline-secondary btn-h-light-green btn-a-green" role="tab" aria-selected="true">
                      Estado de arte
                    </a>
                  </li>

                  <li data-aos="fade-up" data-aos-delay="300" class="nav-item mx-2px mb-1">
                    <a data-toggle="tab" href="#reason2" class="btn border-1 radius-round py-2 px-35 btn-outline-secondary btn-h-light-orange btn-a-orange" role="tab" aria-selected="false">
                      Responsive
                    </a>
                  </li>

                  <li data-aos="fade-up" data-aos-delay="400" class="nav-item mx-2px mb-1">
                    <a data-toggle="tab" href="#reason3" class="btn border-1 radius-round py-2 px-35 btn-outline-secondary btn-h-light-blue btn-a-blue" role="tab" aria-selected="false">
                      Facil uso
                    </a>
                  </li>
                </ul><!-- /.nav-tabs -->


                <div data-aos="fade-up" data-aos-delay="300" class="tab-content tab-sliding text-left border-0 mt-5 px-0">

                  <div class="tab-pane px-3 active show" id="reason1">
                    <div class="d-flex flex-column align-items-center flex-md-row align-items-md-start">
                      <div class="flex-grow-1 text-dark-tp3 mt-4 mt-md-0">
                        <h3 class="text-140 text-secondary-d3 text-center text-md-left mt-md-4">
                          ¡Nuestra tecnología es de vanguardia y fiable!
                        </h3>

                        <ul class="list-unstyled ml-3 mt-4">
                          <li class="mb-3">
                            <i class="fa fa-caret-right text-125 text-green mr-1"></i>
                            Arquitectura Tecnológica y Nube (Cloud-Native).
                          </li>
                          <li class="mb-3">
                            <i class="fa fa-caret-right text-125 text-green mr-1"></i>
                            Inteligencia Artificial y Automatización Próxima (IA + RPA).
                          </li>
                          <li>
                            <i class="fa fa-caret-right text-125 text-green mr-1"></i>
                            Experiencia de Usuario (UI/UX) e Hiper-Movilidad.
                          </li>
                        </ul>
                      </div>

                      <div class="d-flex flex-nowrap order-first order-md-last ml-md-4">
                        <!-- the 3 mobile dashboard images -->
                        <div class="mx-n2">
                          <div class="radius-2 shadow-sm border-1 p-2px brc-default-l2 bgc-white">
                            <div class="overflow-hidden radius-1">
                              <img alt="Product image 1" src="{{rest_server}}img/mobile-dash2.png" height="220" />
                            </div>
                          </div>
                        </div>

                        <div class="mx-n2 pos-rel mt-n25">
                          <div class="radius-2 shadow-sm border-1 p-2px brc-default-l2 bgc-white">
                            <div class="overflow-hidden radius-1">
                              <img alt="Product image 2" src="{{rest_server}}img/mobile-dash1.png" height="220" />
                            </div>
                          </div>
                        </div>

                        <div class="mx-n2">
                          <div class="radius-2 shadow-sm border-1 p-2px brc-default-l2 bgc-white">
                            <div class="overflow-hidden radius-1">
                              <img alt="Product image 3" src="{{rest_server}}img/mobile-dash3.png" height="220" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div><!-- /.tab-pane -->


                  <div class="tab-pane px-3" id="reason2">
                    <div class="d-flex flex-column align-items-center flex-md-row align-items-md-start">
                      <div class=" mr-md-4 ">
                        <div class="overflow-hidden radius-1">
                          <img alt="Product image 4" src="{{rest_server}}img/ipad.png" height="250" />
                        </div>
                      </div>

                      <div class="flex-grow-1 text-dark-tp3 mt-4 mt-md-0">
                        <h3 class="text-140 text-secondary-d3 text-center text-md-left mt-md-4">Fully responsive!</h3>
                        <ul class="list-unstyled ml-3 mt-4">
                          <li class="mb-3">
                            <i class="fa fa-caret-right text-125 text-orange mr-1"></i>
                            El diseño responsive permite que una interfaz se adapte automáticamente al tamaño de cualquier pantalla.
                          </li>
                          <li class="mb-3">
                            <i class="fa fa-caret-right text-125 text-orange mr-1"></i>
                            Mediante rejillas fluidas, reorganiza menús, tablas y botones para que la navegación sea cómoda tanto en monitores como en celulares.
                          </li>
                          <li>
                            <i class="fa fa-caret-right text-125 text-orange mr-1"></i>
                            Este enfoque unifica el desarrollo en un solo código, reduciendo los tiempos y costos de mantenimiento del software.
                          </li>
                          <li>
                            <i class="fa fa-caret-right text-125 text-orange mr-1"></i>
                            En un ERP, garantiza que el usuario pueda operar datos críticos en movimiento sin necesidad de hacer zoom incómodo.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div><!-- /.tab-pane -->


                  <div class="tab-pane px-3" id="reason3">
                    <div class="d-flex flex-column align-items-center flex-md-row align-items-md-start">
                      <div class="flex-grow-1 text-dark-tp3 mt-4 mt-md-0">
                        <h3 class="text-140 text-secondary-d3 text-center text-md-left mt-md-4">
                          Facil de usar
                        </h3>

                        <ul class="list-unstyled ml-3 mt-4">
                          <li class="mb-3">
                            <i class="fa fa-caret-right text-125 text-blue mr-1"></i>
                            cuenta con un diseño intuitivo y familiar que permite a cualquier empleado dominar la plataforma sin necesidad de capacitaciones eternas.
                          </li>
                          <li class="mb-3">
                            <i class="fa fa-caret-right text-125 text-blue mr-1"></i>
                            Esta facilidad garantiza una alta eficiencia operativa, organizando visualmente la interfaz para que las tareas críticas se realicen en un máximo de tres clics.
                          </li>
                          <li>
                            <i class="fa fa-caret-right text-125 text-blue mr-1"></i>
                            También ofrece tolerancia al error, eliminando el miedo a fallar mediante opciones sencillas para deshacer acciones y alertas explicadas en lenguaje humano.
                          </li>
                          <li>
                            <i class="fa fa-caret-right text-125 text-blue mr-1"></i>
                            Se traduce en una experiencia accesible y adaptable, asegurando un uso cómodo y fluido tanto en computadoras de oficina como en teléfonos móviles.
                          </li>
                        </ul>
                      </div>

                      <div class="radius-2 ml-md-4 shadow-sm border-1 p-2px brc-default-l2 bgc-white order-first order-md-last">
                        <div class="overflow-hidden radius-1">
                          <img alt="Product image 5" src="{{rest_server}}img/layout-code.png" width="320" />
                        </div>
                      </div>
                    </div>
                  </div><!-- /.tab-pane -->
                </div><!-- /.tab-content -->

              </div><!-- /.col -->
            </div><!-- /.row -->
          </div><!-- /.container -->

        </div>




        <!-- Other features -->
        <div class="bgc-success-l3" id="otras_caracteristicas">
          <div class="container container-plus pb-45">
            <hr class="brc-secondary-l3 mb-4" />

            <div class="row">
              <div class="col-lg-8 mx-auto">
                <div class="text-center">
                  <h2 class="text-grey-d3 text-160 mb-45">Y otras caracteristicas adicionales</h2>
                </div>

                <div class="row">
                  <div class="col-4 offset-2">
                    <ul class="list-unstyled text-120 text-white">
                      <li class="mb-2 bgc-info-d2 px-35 py-25">
                        <i class="w-5 far fa-clock text-170 align-middle mr-2"></i>
                        <span class="align-middle">Soporte 24/7</span>
                      </li>

                      <li class="mb-2 bgc-info-d2 px-35 py-25">
                        <i class="w-5 fa fa-code text-170 align-middle mr-2"></i>
                        <span class="align-middle">Completamente Documentado</span>
                      </li>

                      <li class="mb-2 bgc-info-d2 px-35 py-25">
                        <i class="w-5 fa fa-dice-d6 text-170 align-middle mr-2"></i>
                        <span class="align-middle">Backups Seguros</span>
                      </li>
                    </ul>
                  </div>


                  <div class="col-4">
                    <ul class="list-unstyled text-120 text-white">
                      <li class="mb-2 bgc-info-d2 text-white px-35 py-25">
                        <i class="w-5 fa fa-redo text-170 align-middle mr-2"></i>
                        <span class="align-middle">Actualizaciones Regulares</span>
                      </li>

                      <li class="mb-2 bgc-info-d2 px-35 py-25">
                        <i class="w-5 fa fa-eye text-170 align-middle mr-2"></i>
                        <span class="align-middle">Privacidad Máxima</span>
                      </li>

                      <li class="mb-2  bgc-info-d2 px-35 py-25">
                        <i class="w-5 fa fa-rocket text-170 align-middle mr-2"></i>
                        <span class="align-middle">Velocidad Sin Igual</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>





        <div class="pb-3" id="clientes">
          <div class="container container-plus py-3 my-45 px-lg-5">
              <div class="row">
                <div class="col-lg-9 mx-auto">
                  <h4 class="text-dark-tp3 text-center text-160 mb-2">
                    Nuestros Clientes
                  </h4>
                  <hr class="brc-secondary-l3" />

                  <div class="row text-130 mt-4">
                    @for (empresa of empresas; track empresa.id) {
                    <div class="col-4 col-sm-3 col-md-2 text-center my-2">
                      <img class="pull-left" src="{{rest_server+empresa.imagen}}" width="100" height="100" /><br>
                      <span class="text-90 text-muted">{{empresa.nombre.toUpperCase()}}</span>
                    </div>
                    }
                  </div><!-- /.row -->
                </div><!-- /.col -->
              </div><!-- /.row -->
            </div>
        </div>




        <div class="bgc-primary-l3" id="comercios">
          <div  class="container container-plus py-5">
            <h3 class="text-center text-dark-tp3 text-160 mb-2 mb-md-4 mb-lg-5" data-aos="fade-down">
              Paquete Comercios
            </h3>
            <h4 class="text-dark-tp4 pl-1 text-center">
              Para cualquier negocio de compra y venta
            </h4>
            <div>
              <div class="row col-lg-10 d-flex justify-content-center mx-1 mx-lg-auto mt-3">

                <div class="col-12 col-sm-6 col-lg-4 col-xl-3 px-2 dh-zoom-1">
                  <!-- Basic -->
                  <div data-aos="fade-right" data-aos-delay="200" class="d-style btn btn-outline-default btn-h-outline-blue btn-a-outline-blue bgc-white w-100 border-none border-t-3 radius-b-1 my-2 p-0 pt-2 shadow">

                    <div class="d-flex flex-column align-items-center">

                      <h4 class="pt-1 pb-15 px-4 radius-4 text-110 bgc-blue-l3 text-blue-d3 my-3 radius-1">
                        Plan Basico
                      </h4>

                      <div class="text-secondary-d2 text-80">
                        <span class="text-green-d2">Bs<span class="text-100">2450</span> / Licencia de uso perpetuo</span>
                      </div>
                      <div class="text-secondary-d2 text-130">
                        Bs<span class="text-200">190</span> / mes
                      </div>

                      <hr class="w-90 my-4 brc-secondary-l3" />

                      <div class="text-grey text-90 w-100">
                        <ul class="list-unstyled text-left m-0">
                          <li class="mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110">Gastos de operación</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 ">Ventas con recibo</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 ">Cotizaciones</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 ">Gestión de clientes</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 ">Gestión de proveedores</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 ">Reporte de gastos</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 ">Reporte de ventas</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 ">Gestión de usuarios (5 cuentas de usuario)</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 ">Incluye soporte técnico</span>
                          </li>

                          <li class="mt-3 mx-4">
                            <i class="fa fa-times text-danger-m3 text-110 mr-1 mt-1"></i>
                            <span class="text-110">No incluye gestion de inventarios</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-times text-danger-m3 text-110 mr-1 mt-1"></i>
                            <span class="text-110">No incluye Facturacion electronica</span>
                          </li>

                          <li class="mt-45">
                            <a href="#" class="d-hover btn radius-0 btn-blue py-3 border-0 btn-block px-3 btn-bold text-105">Empieza ahora</a>
                            <a href="#" class="d-n-hover btn radius-0 btn-default py-3 border-0 btn-block px-3 btn-bold text-105">Empieza ahora</a>
                          </li>
                        </ul>
                      </div>

                    </div>

                  </div>
                </div>
                <div class="col-12 col-sm-6 col-lg-4 col-xl-3 px-2 dh-zoom-1">
                  <!-- Basic -->
                  <div data-aos="fade-right" data-aos-delay="200" class="d-style btn btn-outline-default btn-h-outline-blue btn-a-outline-blue bgc-white w-100 border-none border-t-3 radius-b-1 my-2 p-0 pt-2 shadow">

                    <div class="d-flex flex-column align-items-center">

                      <h4 class="pt-1 pb-15 px-4 radius-4 text-110 bgc-blue-l3 text-blue-d3 my-3 radius-1">
                        Plan Premium
                      </h4>

                      <div class="text-secondary-d2 text-80">
                        <span class="text-green-d2">Bs<span class="text-100">3390</span> / Licencia de uso perpetuo</span>
                      </div>
                      <div class="text-secondary-d2 text-130">
                        Bs<span class="text-200">290</span> / mes
                      </div>

                      <hr class="w-90 my-4 brc-secondary-l3" />

                      <div class="text-grey text-90 w-100">
                        <ul class="list-unstyled text-left m-0">
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Incluye Plan Basico</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Compras</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Control de inventario</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Movimiento de inventario, inv. inicial, bajas y ajustes</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Combos u ofertas</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Cuentas por cobrar y reporte</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Cuentas por pagar y reporte</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Reporte de inventarios</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Reporte de compras</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">10 cuentas de usuario</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Incluye soporte técnico</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-times text-danger-m3 text-110 mr-1 mt-1"></i>
                            <span class="text-110">No incluye Facturacion electronica</span>
                          </li>
                          <li class="mt-45">
                            <a href="#" class="btn radius-0 btn-green py-3 border-0 btn-block px-3 btn-bold text-105">Empieza ahora</a>
                          </li>
                        </ul>
                      </div>

                    </div>

                  </div>
                </div>



                <div class="col-12 col-sm-6 col-lg-4 col-xl-3 px-2 dh-zoom-1 mt-lg-n3">
                  <!-- Pro -->
                  <div data-aos="fade" data-aos-delay="100" class="d-style active btn btn-outline-default btn-h-outline-green btn-a-outline-green bgc-white w-100 border-none border-t-3 radius-b-1 my-2 p-0 pt-2 shadow">

                    <div class="d-flex flex-column align-items-center">

                      <h4 class="pt-1 pb-15 px-4 radius-4 text-110 bgc-green-l2 text-green-d3 my-3 radius-1">
                        Plan Profesional
                      </h4>

                      <div>
                        <div class="text-secondary-d2 text-80">
                          <span class="text-green-d2">Bs<span class="text-100">4100</span> / Licencia de uso perpetuo</span>
                        </div>
                        <div class="text-130">
                          <span class="text-green-d2">Bs<span class="text-200">490</span> / mes</span>
                        </div>
                      </div>

                      <hr class="w-90 my-4 brc-secondary-l3" />

                      <div class="text-grey text-90 w-100">
                        <ul class="list-unstyled text-left m-0">
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Incluye Plan Premium</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Facturación Electrónica</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Libro de Compras</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Libro de Ventas</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Cierre y arqueo de caja</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Notificaciones sobre inventario mínimo</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Notificaciones sobre cuentas por cobrar y pagar</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">15 cuentas de usuario</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Incluye soporte técnico</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-times text-danger-m3 text-110 mr-1 mt-1"></i>
                            <span class="text-110">No incluye Manejo de Sucursales</span>
                          </li>
                          <li class="mt-45">
                            <a href="#" class="btn radius-0 btn-green py-3 border-0 btn-block px-3 btn-bold text-105">Empieza ahora</a>
                          </li>
                        </ul>
                      </div>


                    </div>

                  </div>
                </div>



                <div class="col-12 col-sm-6 col-lg-4 col-xl-3 px-2 dh-zoom-1">
                  <!-- Max -->
                  <div data-aos="fade-left" data-aos-delay="200" class="d-style btn btn-outline-default btn-h-outline-purple btn-a-outline-purple bgc-white w-100 border-none border-t-3 radius-b-1 my-2 p-0 pt-2 shadow">

                    <div class="d-flex flex-column align-items-center">

                      <h4 class="pt-1 pb-15 px-4 radius-4 text-110 bgc-purple-l3 text-purple-d3 my-3 radius-1">
                        Plan Master
                      </h4>

                      <div class="text-secondary-d2 text-80">
                        <span class="text-green-d2">Bs<span class="text-100">5900</span> / Licencia de uso perpetuo</span>
                      </div>
                      <div class="text-secondary-d2 text-130">
                        Bs<span class="text-200">650</span> / mes
                      </div>

                      <hr class="w-90 my-4 brc-secondary-l3" />

                      <div class="text-grey text-90 w-100">
                        <ul class="list-unstyled text-left m-0">
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110">Incluye Plan Profesional</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110">Sucursal Adicional y almacenes</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110">Geolocalización de clientes</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110">Precios de productos por sucursal, cliente y vendedor</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110">Movimiento de inventario, traspaso entre almacenes</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110">Ilimitadas cuentas de usuario</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110">Incluye soporte técnico</span>
                          </li>
                          <li class="mt-45">
                            <a href="#" class="d-hover btn radius-0 btn-purple py-3 border-0 btn-block px-3 btn-bold text-105">Empieza ahora</a>
                            <a href="#" class="d-n-hover btn radius-0 btn-default py-3 border-0 btn-block px-3 btn-bold text-105">Empieza ahora</a>
                          </li>
                        </ul>
                      </div>


                    </div>

                  </div>
                </div>

              </div><!-- ./row -->
            </div>
          </div>
        </div>

        <div class="bgc-primary-l3" id="restaurantes">
          <div id="caracteristicas" class="container container-plus py-5">
            <h3 class="text-center text-dark-tp3 text-160 mb-2 mb-md-4 mb-lg-5" data-aos="fade-down">
              Paquete Restaurantes
            </h3>
            <h4 class="text-dark-tp4 pl-1 text-center">
              Para restaurantes, bares, cafeterias, foodtrucks y otros negocios de comida
            </h4>

            <div>
              <div class="row col-lg-10 d-flex justify-content-center mx-1 mx-lg-auto mt-3">

                <div class="col-12 col-sm-6 col-lg-4 col-xl-3 px-2 dh-zoom-1">
                  <!-- Basic -->
                  <div data-aos="fade-right" data-aos-delay="200" class="d-style btn btn-outline-default btn-h-outline-blue btn-a-outline-blue bgc-white w-100 border-none border-t-3 radius-b-1 my-2 p-0 pt-2 shadow">

                    <div class="d-flex flex-column align-items-center">

                      <h4 class="pt-1 pb-15 px-4 radius-4 text-110 bgc-blue-l3 text-blue-d3 my-3 radius-1">
                        Plan Basico
                      </h4>

                      <div class="text-secondary-d2 text-80">
                        <span class="text-green-d2">Bs<span class="text-100">2450</span> / Licencia de uso perpetuo</span>
                      </div>
                      <div class="text-secondary-d2 text-130">
                        Bs<span class="text-200">190</span> / mes
                      </div>

                      <hr class="w-90 my-4 brc-secondary-l3" />

                      <div class="text-grey text-90 w-100">
                        <ul class="list-unstyled text-left m-0">
                          <li class="mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110">Gastos de operación</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 ">Ventas con recibo</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 ">Pedidos</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 ">Gestión de clientes</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 ">Gestión de proveedores</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 ">Despacho de pedidos desde cocina mediante tablet</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 ">Reporte de gastos</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 ">Reporte de ventas</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 ">Gestión de usuarios (5 cuentas de usuario)</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 ">Incluye soporte técnico</span>
                          </li>

                          <li class="mt-3 mx-4">
                            <i class="fa fa-times text-danger-m3 text-110 mr-1 mt-1"></i>
                            <span class="text-110">No incluye gestion de inventarios</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-times text-danger-m3 text-110 mr-1 mt-1"></i>
                            <span class="text-110">No incluye Facturacion electronica</span>
                          </li>

                          <li class="mt-45">
                            <a href="#" class="d-hover btn radius-0 btn-blue py-3 border-0 btn-block px-3 btn-bold text-105">Empieza ahora</a>
                            <a href="#" class="d-n-hover btn radius-0 btn-default py-3 border-0 btn-block px-3 btn-bold text-105">Empieza ahora</a>
                          </li>
                        </ul>
                      </div>

                    </div>

                  </div>
                </div>
                <div class="col-12 col-sm-6 col-lg-4 col-xl-3 px-2 dh-zoom-1">
                  <!-- Basic -->
                  <div data-aos="fade-right" data-aos-delay="200" class="d-style btn btn-outline-default btn-h-outline-blue btn-a-outline-blue bgc-white w-100 border-none border-t-3 radius-b-1 my-2 p-0 pt-2 shadow">

                    <div class="d-flex flex-column align-items-center">

                      <h4 class="pt-1 pb-15 px-4 radius-4 text-110 bgc-blue-l3 text-blue-d3 my-3 radius-1">
                        Plan Premium
                      </h4>

                      <div class="text-secondary-d2 text-80">
                        <span class="text-green-d2">Bs<span class="text-100">3390</span> / Licencia de uso perpetuo</span>
                      </div>
                      <div class="text-secondary-d2 text-130">
                        Bs<span class="text-200">290</span> / mes
                      </div>

                      <hr class="w-90 my-4 brc-secondary-l3" />

                      <div class="text-grey text-90 w-100">
                        <ul class="list-unstyled text-left m-0">
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Incluye Plan Basico</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Toma de pedidos del mesero</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Publicidad de productos en pantalla de cliente</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Control de inventario</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Movimiento de inventario, inv. inicial, bajas y ajustes</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Cuentas por cobrar y reporte</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Cuentas por pagar y reporte</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Reporte de inventarios</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Reporte de compras</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">10 cuentas de usuario</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Incluye soporte técnico</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-times text-danger-m3 text-110 mr-1 mt-1"></i>
                            <span class="text-110">No incluye Facturacion electronica</span>
                          </li>
                          <li class="mt-45">
                            <a href="#" class="btn radius-0 btn-green py-3 border-0 btn-block px-3 btn-bold text-105">Empieza ahora</a>
                          </li>
                        </ul>
                      </div>

                    </div>

                  </div>
                </div>



                <div class="col-12 col-sm-6 col-lg-4 col-xl-3 px-2 dh-zoom-1 mt-lg-n3">
                  <!-- Pro -->
                  <div data-aos="fade" data-aos-delay="100" class="d-style active btn btn-outline-default btn-h-outline-green btn-a-outline-green bgc-white w-100 border-none border-t-3 radius-b-1 my-2 p-0 pt-2 shadow">

                    <div class="d-flex flex-column align-items-center">

                      <h4 class="pt-1 pb-15 px-4 radius-4 text-110 bgc-green-l2 text-green-d3 my-3 radius-1">
                        Plan Profesional
                      </h4>

                      <div>
                        <div class="text-secondary-d2 text-80">
                          <span class="text-green-d2">Bs<span class="text-100">4100</span> / Licencia de uso perpetuo</span>
                        </div>
                        <div class="text-130">
                          <span class="text-green-d2">Bs<span class="text-200">490</span> / mes</span>
                        </div>
                      </div>

                      <hr class="w-90 my-4 brc-secondary-l3" />

                      <div class="text-grey text-90 w-100">
                        <ul class="list-unstyled text-left m-0">
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Incluye Plan Premium</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Control de salas</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Control de mesas</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Gestión de meseros</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Facturación Electrónica</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Libro de Compras</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Libro de Ventas</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Cierre y arqueo de caja</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Notificaciones sobre inventario mínimo</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Notificaciones sobre cuentas por cobrar y pagar</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">15 cuentas de usuario</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110 text-1">Incluye soporte técnico</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-times text-danger-m3 text-110 mr-1 mt-1"></i>
                            <span class="text-110">No incluye Manejo de Sucursales</span>
                          </li>
                          <li class="mt-45">
                            <a href="#" class="btn radius-0 btn-green py-3 border-0 btn-block px-3 btn-bold text-105">Empieza ahora</a>
                          </li>
                        </ul>
                      </div>


                    </div>

                  </div>
                </div>



                <div class="col-12 col-sm-6 col-lg-4 col-xl-3 px-2 dh-zoom-1">
                  <!-- Max -->
                  <div data-aos="fade-left" data-aos-delay="200" class="d-style btn btn-outline-default btn-h-outline-purple btn-a-outline-purple bgc-white w-100 border-none border-t-3 radius-b-1 my-2 p-0 pt-2 shadow">

                    <div class="d-flex flex-column align-items-center">

                      <h4 class="pt-1 pb-15 px-4 radius-4 text-110 bgc-purple-l3 text-purple-d3 my-3 radius-1">
                        Plan Master
                      </h4>

                      <div class="text-secondary-d2 text-80">
                        <span class="text-green-d2">Bs<span class="text-100">5900</span> / Licencia de uso perpetuo</span>
                      </div>
                      <div class="text-secondary-d2 text-130">
                        Bs<span class="text-200">650</span> / mes
                      </div>

                      <hr class="w-90 my-4 brc-secondary-l3" />

                      <div class="text-grey text-90 w-100">
                        <ul class="list-unstyled text-left m-0">
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110">Incluye Plan Profesional</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110">Sucursal Adicional y almacenes</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110">Formulación de recetas y control de inventario</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110">Reporte de materias primas para preparación de menú</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110">Gestión de comenzales a nivel semanal y mensual</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110">Movimiento de inventario, traspaso entre almacenes</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110">Ilimitadas cuentas de usuario</span>
                          </li>
                          <li class="mt-3 mx-4">
                            <i class="fa fa-check text-success-m2 text-110 mr-1 mt-1"></i>
                            <span class="text-110">Incluye soporte técnico</span>
                          </li>
                          <li class="mt-45">
                            <a href="#" class="d-hover btn radius-0 btn-purple py-3 border-0 btn-block px-3 btn-bold text-105">Empieza ahora</a>
                            <a href="#" class="d-n-hover btn radius-0 btn-default py-3 border-0 btn-block px-3 btn-bold text-105">Empieza ahora</a>
                          </li>
                        </ul>
                      </div>


                    </div>

                  </div>
                </div>

              </div><!-- ./row -->
            </div>
          </div>
        </div>



        <div class="footer h-auto">
          <div class="footer-inner py-45">
            <div class="container container-plus" data-aos="fade">
              <div class="row">
                <div class="col-12 col-lg-5">
                  <h2 class="text-dark-m3">
                    <img class="pull-left" src="{{rest_server+'img/'+datos_app.logo}}" width="30" height="30" />
                    <span> {{datos_app.nombre}}</span>
                  </h2>

                  <p class="text-90">
                    Tu negocio en tus manos!
                  </p>

                  <div class="text-150 mt-2">
                    <a href="{{datos_app.canal_whatsapp}}" target="_blank" type="button" class="btn btn-bgc-white btn-lighter-green btn-h-success btn-a-success border-2 radius-round btn-lg px-25 mx-1">
                      <i class="fab fa-whatsapp text-110"></i>
                    </a>
                    <!--<a href="{{datos_app.canal_web}}" target="_blank" type="button" class="btn btn-bgc-white btn-lighter-blue btn-h-info btn-a-info border-2 radius-round btn-lg px-25 mx-1">
                      <i class="fas fa-globe text-110"></i>
                    </a>-->

                    <a href="{{datos_app.canal_facebook}}" target="_blank" type="button" class="btn btn-bgc-white btn-lighter-primary btn-h-primary btn-a-primary border-2 radius-round btn-lg mx-1">
                      <i class="fab fa-facebook-f text-110"></i>
                    </a>

                    <a href="{{datos_app.canal_youtube}}" target="_blank" type="button" class="btn btn-bgc-white btn-lighter-red btn-h-red btn-a-red border-2 radius-round btn-lg px-25 mx-1">
                      <i class="fab fa-youtube text-110"></i>
                    </a>
                  </div>
                </div>

                <div class="col-12 col-lg-7 mt-5 mt-lg-0">
                  <div class="row text-center text-lg-left">
                    <!--
                    <div class="col-4 ">
                      <h6 class="text-dark-tp3 text-95 text-600 mb-3">ABOUT</h6>
                      <div>
                        <a href="#" class="text-dark-tp4">Link 1</a>
                        <br />
                        <a href="#" class="text-dark-tp4">Link 2</a>
                      </div>
                    </div>

                    <div class="col-4">
                      <h6 class="text-dark-tp3 text-95 text-600 mb-3">PRODUCTS</h6>
                      <div>
                        <a href="#" class="text-dark-tp4">Product 1</a>
                        <br />
                        <a href="#" class="text-dark-tp4">Product 2</a>
                        <br />
                        <a href="#" class="text-dark-tp4">Product 3</a>
                      </div>
                    </div>

                    <div class="col-4">
                      <h6 class="text-dark-tp3 text-95 text-600 mb-3">CONTACT</h6>
                      <div>
                        <a href="#" class="text-dark-tp4">Email</a>
                        <br />
                        <a href="#" class="text-dark-tp4">Phone</a>
                        <br />
                        <a href="#" class="text-dark-tp4">Address</a>
                      </div>
                    </div>-->
                  </div>
                </div>
              </div><!-- /.row -->

            </div><!-- /.container -->
          </div><!-- /.footer-inner -->
        </div><!-- /.footer -->



        <div class="text-center py-4 bgc-primary-l4 border-t-1 brc-primary-l3">
          <span class="text-dark-m3 text-105">
    Todos los derechos reservados &copy; 2026 Snapquick App
</span>
        </div>



        <div class="footer-tools">
          <a href="#" class="btn-scroll-up btn btn-dark px-25 py-2 text-95 border-2 radius-round mb-2 mr-2">
            <i class="fa fa-arrow-up w-2 h-2"></i>
          </a>
        </div>
      </div>
    </div>

  </div>

</div>